import { createUseStyles } from '@glu/theming';

export default createUseStyles(({
  nav: {
    iconLink,
    link
  }
}) => ({
  icon: {
    flexGrow: 0,
    marginRight: 10,
    display: 'flex'
  },

  iconLink: {
    alignItems: 'center',
    display: 'flex',
    fontSize: iconLink.fontSize,
    '& svg': {
      fill: link.color
    }
  }
}));
